const root = `${process.env.PUBLIC_URL || ""}/audio/victory`;
export const VICTORY_RECORDINGS = [
  { file: "Deeeeamn-You-Col-Getting-Dumb.m4a", message: "Deeeeamn. You col’ getting dumb!" },
  { file: "This-MF-Cold.m4a", message: "This MF COLD!" },
  { file: "Someone-Check-This-MFs-Credentials.m4a", message: "Someone check this MF’s credentials!" },
].map(item => ({ ...item, path: `${root}/${item.file}` }));
const seen = new Set();
let lastIndex = null;
const storage = () => window.localStorage;
export function nextVictoryRecording() {
  if (lastIndex === null) {
    try {
      const saved = storage().getItem("hhkd.victory.lastVoice");
      if (/^[0-2]$/.test(saved)) lastIndex = Number(saved);
    } catch {}
  }
  lastIndex = ((lastIndex ?? -1) + 1) % VICTORY_RECORDINGS.length;
  try { storage().setItem("hhkd.victory.lastVoice", String(lastIndex)); } catch {}
  return VICTORY_RECORDINGS[lastIndex];
}
// Arm only from /game/start, never from a render or a restored result.
export function createVictorySession() {
  let active = true, eligible = false, claimed = false, key = null;
  let generation = 0, stopAudio = () => {};
  return {
    activate(stop = () => {}) { active = true; stopAudio = stop; },
    begin() { generation += 1; eligible = false; stopAudio(); },
    get token() { return generation; },
    isCurrent(token) { return active && token === generation; },
    dispose() { active = false; },
    get active() { return active; },
    get completed() { return claimed || (key !== null && !eligible); },
    arm(identity, alreadySolved) {
      const nextKey = `hhkd.victory.completed:${JSON.stringify(identity)}`;
      if (nextKey !== key) claimed = false;
      key = nextKey;
      eligible = !alreadySolved;
    },
    claim(result) {
      if (!active || !eligible || claimed || !key || !result.perfect || result.already_solved || result.solvedBefore) return null;
      claimed = true;
      if (seen.has(key)) return null;
      try { if (storage().getItem(key) === "1") return null; } catch {}
      seen.add(key);
      try { storage().setItem(key, "1"); } catch {}
      return nextVictoryRecording();
    },
  };
}
